import { render, staticRenderFns } from "./Offers.vue?vue&type=template&id=b2b53c1c"
import script from "./Offers.vue?vue&type=script&lang=js"
export * from "./Offers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/applications/abenity.com-cb0cd5ae/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2b53c1c')) {
      api.createRecord('b2b53c1c', component.options)
    } else {
      api.reload('b2b53c1c', component.options)
    }
    module.hot.accept("./Offers.vue?vue&type=template&id=b2b53c1c", function () {
      api.rerender('b2b53c1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/vue-components/Offers.vue"
export default component.exports